import { stages } from 'Constants/stages';

export const RelevantStages = [stages.DATA_RETRIEVAL, stages.DATA_PULLED, stages.DATA_PULLING];
